var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes,attrs:{"data-preload":[_vm.$options.name]}},_vm._l((_vm.items),function(item,index){return _c('div',{key:index,class:['itemWrap', { 'itemWrap--bordered': _vm.items.length === 4 }]},[_c('UspItem',_vm._b({},'UspItem',item,false))],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }